import { IconButton, Stack } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';

type Props = {
    index: number;
    count: number;
    label: string;
    onMove: (from: number, to: number) => void;
};

/*
    Moves one row of a list up or down. It takes an index, not the item, so two equal rows are not
    confused. The Angular cf-reorder-list-item-buttons stays where it is for the lesson editor.
*/
export default function ReorderButtons({ index, count, label, onMove }: Props) {
    return (
        <Stack direction="row" spacing={0}>
            <IconButton
                name="moveUp"
                size="small"
                aria-label={`Move ${label} up`}
                disabled={index === 0}
                onClick={() => onMove(index, index - 1)}
            >
                <ArrowUpward fontSize="small" />
            </IconButton>

            <IconButton
                name="moveDown"
                size="small"
                aria-label={`Move ${label} down`}
                disabled={index >= count - 1}
                onClick={() => onMove(index, index + 1)}
            >
                <ArrowDownward fontSize="small" />
            </IconButton>
        </Stack>
    );
}
